module.exports = __webpack_public_path__ + "img/gift.74dc5b0f.png";